import { useDispatch as useReduxDispatch } from "react-redux";
import { type store } from "store";

export type Dispatch = (typeof store)["dispatch"];

export const useDispatch = useReduxDispatch as () => (typeof store)["dispatch"];
